import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Contact: React.FC = () => {
	const [formData, setFormData] = React.useState({
		name: '',
		email: '',
		subject: '',
		message: '',
	});

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		alert('Thank you for your message! We will get back to you soon.');
		setFormData({ name: '', email: '', subject: '', message: '' });
	};

	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Contact Us
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text color="#3d3d3d" size={16} center>
						Have questions or need support? We're here to help! Get in touch with our team using the form below or contact us directly.
					</Text>
				</ContentSection>

				<Spacer size={60} />

				<FormContainer>
					<form onSubmit={handleSubmit}>
						<FormGroup>
							<Label htmlFor="name">Name</Label>
							<Input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" />
						</FormGroup>

						<FormGroup>
							<Label htmlFor="email">Email</Label>
							<Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
						</FormGroup>

						<FormGroup>
							<Label htmlFor="subject">Subject</Label>
							<Input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="How can we help?" />
						</FormGroup>

						<FormGroup>
							<Label htmlFor="message">Message</Label>
							<TextArea id="message" name="message" value={formData.message} onChange={handleChange} required placeholder="Tell us more..." rows={6} />
						</FormGroup>

						<SubmitButton type="submit">Send Message</SubmitButton>
					</form>
				</FormContainer>

				<Spacer size={80} />

				<ContactInfo>
					<InfoSection>
						<Text weight="bold" size={20}>
							Customer Support
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							<strong>Email:</strong> support@liverewardsgo.com
							<br />
							<strong>Phone:</strong> 1-800-REWARDS
							<br />
							<strong>Hours:</strong> Monday - Friday, 9am - 5pm PST
						</Text>
					</InfoSection>

					<Spacer size={40} />

					<InfoSection>
						<Text weight="bold" size={20}>
							Business Inquiries
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							<strong>Email:</strong> business@liverewardsgo.com
							<br />
							<strong>Phone:</strong> 1-800-REWARDS
						</Text>
					</InfoSection>

					<Spacer size={40} />

					<InfoSection>
						<Text weight="bold" size={20}>
							Press & Media
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							<strong>Email:</strong> press@liverewardsgo.com
							<br />
							<strong>Phone:</strong> 1-800-REWARDS
						</Text>
					</InfoSection>
				</ContactInfo>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;

const FormContainer = styled.div`
	max-width: 600px;
	width: 100%;
`;

const FormGroup = styled.div`
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
`;

const Label = styled.label`
	font-weight: 600;
	margin-bottom: 8px;
	color: #0d2b2f;
	font-size: 16px;
`;

const Input = styled.input`
	padding: 12px;
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	font-size: 16px;
	font-family: inherit;
	transition: border-color 0.2s ease;

	&:focus {
		outline: none;
		border-color: #165a63;
	}
`;

const TextArea = styled.textarea`
	padding: 12px;
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	font-size: 16px;
	font-family: inherit;
	resize: vertical;
	transition: border-color 0.2s ease;

	&:focus {
		outline: none;
		border-color: #165a63;
	}
`;

const SubmitButton = styled.button`
	background-color: #165a63;
	color: white;
	padding: 12px 30px;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #0d2b2f;
	}

	&:active {
		transform: scale(0.98);
	}
`;

const ContactInfo = styled.div`
	max-width: 800px;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	gap: 30px;

	@media only screen and (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
	}
`;

const InfoSection = styled.div`
	padding: 20px;
	background-color: #f5f5f5;
	border-radius: 8px;
`;
